export const checkType = (context, type) => {
  let competitionTypes = context.competition?.type;
  return competitionTypes.find((t) => t.title === type) !== undefined
    ? true
    : false;
};
